export default __webpack_public_path__ + "c09e16a0ae66bea34b59e4ac343cdd2d.png";